// // Get all sections and buttons
// const step1Section = document.querySelector('.qf-step-1');
// const step2Section = document.querySelector('.qf-step-2');
// const step3Section = document.querySelector('.qf-step-3');
// const step4Section = document.querySelector('.qf-step-4');
// const step5Section = document.querySelector('.qf-step-5');
// const step6Section = document.querySelector('.qf-step-6');
// const step7Section = document.querySelector('.qf-step-7');
// const supportSection = document.querySelector('.new-supp');
// const progressBar = document.querySelector('.qf-progress');
// const progressBrMain = document.querySelector('.qf-progress-bar');
// const progressActive = document.querySelector('.qf-progress-active');

// const step1Button = document.querySelector('.qf-step1-btn');
// const emailInput = document.querySelector('.new-email-inp');

// // Disable step1 button initially
// if (step1Button) {
//   step1Button.disabled = true;
//   step1Button.classList.remove('active');
// }

// const locationButton = document.querySelector('.location-btn');
// const step3Button = document.querySelector('.qf-slide-btn-text');
// const step4Button = document.querySelector('.qf-step-4-btn');
// const step5Button = document.querySelector('.qf-step5-btn');
// const step6Button = document.querySelector('.qf-step6-btn');

// // ============= SCROLL TO TOP HELPER =============
// function scrollToTop() {
//   window.scrollTo({
//     top: 0,
//     behavior: 'smooth'
//   });
// }

// // ============= URL PARAMETER FUNCTIONS =============
// function getUrlParameter(name) {
//   const urlParams = new URLSearchParams(window.location.search);
//   return urlParams.get(name);
// }

// function updateUrlWithParams(email, packageType) {
//   const currentUrl = new URL(window.location.href);
//   currentUrl.searchParams.set('email', email);
//   currentUrl.searchParams.set('package', packageType);
//   window.history.pushState({}, '', currentUrl);
// }

// function goToStep(stepNumber) {
//   const allSections = [step1Section, step2Section, step3Section, step4Section, step5Section, step6Section, step7Section, supportSection];
//   allSections.forEach(section => {
//     if (section) {
//       section.classList.remove('question-active');
//       section.classList.add('question-inactive');
//     }
//   });

//   let targetSection;
//   switch (stepNumber) {
//     case 1: targetSection = step1Section; break;
//     case 2: targetSection = step2Section; break;
//     case 3: targetSection = step3Section; break;
//     case 4: targetSection = step4Section; break;
//     case 5: targetSection = step5Section; break;
//     case 6: targetSection = step6Section; break;
//     case 7:
//       targetSection = step7Section;
//       const packageParam = getUrlParameter('package');
//       filterStep7Packages(packageParam);
//       break;
//     case 'support': targetSection = supportSection; break;
//     default: targetSection = step1Section;
//   }

//   if (targetSection) {
//     targetSection.classList.remove('question-inactive');
//     targetSection.classList.add('question-active');
//   }

//   updateProgressBar(stepNumber);
//   scrollToTop(); // ✅ Scroll to top when changing steps
// }

// // Check URL on page load
// window.addEventListener('DOMContentLoaded', function() {
//   const emailParam = getUrlParameter('email');
//   const packageParam = getUrlParameter('package');

//   filterStep7Packages(packageParam);

//   if (emailParam && packageParam) {
//     if (emailInput && emailParam) {
//       emailInput.value = decodeURIComponent(emailParam);
//       step1Button.disabled = false;
//       step1Button.classList.add('active');
//     }
//     goToStep(5);
//   } else {
//     updateProgressBar(1);
//   }
// });

// // ============= Filter Packages for Step 7 =============
// function filterStep7Packages(packageParam) {
//   const allPackages = document.querySelectorAll('.qf-step7-inner');
//   if (!packageParam) {
//     allPackages.forEach(pkg => pkg.style.display = 'block');
//     return;
//   }

//   const normalizedPackage = packageParam.toLowerCase().trim();

//   allPackages.forEach(pkg => {
//     const pkgValue = pkg.getAttribute('pkg-value');
//     if (pkgValue) {
//       const normalizedPkgValue = pkgValue.toLowerCase().trim();
//       pkg.style.display = normalizedPkgValue === normalizedPackage ? 'block' : 'none';
//     }
//   });
// }

// // ============= Progress Bar =============
// function updateProgressBar(step) {
//   progressBar.classList.remove('step-1', 'step-2', 'step-3', 'step-4', 'step-5', 'step-6', 'step-7', 'step-support');
//   let widthPercentage;
//   switch (step) {
//     case 1: progressBar.classList.add('step-1'); widthPercentage = 12.5; break;
//     case 2: progressBar.classList.add('step-2'); widthPercentage = 25; break;
//     case 3: progressBar.classList.add('step-3'); widthPercentage = 37.5; break;
//     case 4: progressBar.classList.add('step-4'); progressBrMain.classList.add('step-4'); widthPercentage = 50; break;
//     case 5: progressBrMain.classList.remove('step-4'); progressBar.classList.add('step-5'); widthPercentage = 62.5; break;
//     case 6: progressBar.classList.add('step-6'); widthPercentage = 75; break;
//     case 7: progressBar.classList.add('step-7'); widthPercentage = 100; break;
//     case 'support': progressBar.classList.add('step-support'); widthPercentage = 100; break;
//   }
//   progressActive.style.width = `${widthPercentage}%`;
// }

// // ============= Step 1: Email Validation =============
// if (emailInput && step1Button) {
//   emailInput.addEventListener('input', function() {
//     const email = this.value.trim();
//     const isValid = email && email.includes('@') && email.includes('.');
//     step1Button.disabled = !isValid;
//     step1Button.classList.toggle('active', isValid);
//   });

//   step1Button.addEventListener('click', () => {
//     const email = emailInput.value.trim();
//     if (!email || !email.includes('@')) {
//       alert('Please enter a valid email address');
//       return;
//     }
//     const packageType = 'low';
//     updateUrlWithParams(email, packageType);
//     goToStep(5);
//   });
// }

// // ============= Step 2: Location =============
// const radioInputs = document.querySelectorAll('.qf-radio-inp');
// const searchInput = document.getElementById('siteSearch');
// const dentistLocations = document.querySelectorAll('.qf-dentist-location-single');

// dentistLocations.forEach(location => {
//   location.addEventListener('click', function() {
//     radioInputs.forEach(radio => radio.checked = false);
//     const radio = this.querySelector('.qf-radio-inp');
//     if (radio) {
//       radio.checked = true;
//       checkRadioSelection();
//     }
//   });
// });

// if (searchInput) {
//   searchInput.addEventListener('input', function() {
//     const searchTerm = this.value.toLowerCase();
//     dentistLocations.forEach(location => {
//       const dentistName = location.querySelector('.dentist-location-name')?.textContent.toLowerCase() || '';
//       location.style.display = dentistName.includes(searchTerm) ? 'block' : 'none';
//     });
//   });
// }

// function checkRadioSelection() {
//   const anyChecked = Array.from(radioInputs).some(radio => radio.checked);
//   locationButton.disabled = !anyChecked;
//   locationButton.classList.toggle('active', anyChecked);
// }

// radioInputs.forEach(radio => radio.addEventListener('change', checkRadioSelection));
// checkRadioSelection();

// locationButton.addEventListener('click', function() {
//   if (!this.disabled) {
//     step2Section.classList.remove('question-active');
//     step2Section.classList.add('question-inactive');
//     step3Section.classList.remove('question-inactive');
//     step3Section.classList.add('question-active');
//     updateProgressBar(3);
//     scrollToTop(); // ✅ Scroll to top
//   }
// });

// // ============= Step 3 to Step 4 =============
// step3Button.addEventListener('click', () => {
//   step3Section.classList.remove('question-active');
//   step3Section.classList.add('question-inactive');
//   step4Section.classList.remove('question-inactive');
//   step4Section.classList.add('question-active');
//   updateProgressBar(4);
//   scrollToTop(); // ✅ Scroll to top
// });

// // ============= Step 4 to Step 5 =============
// step4Button.addEventListener('click', () => {
//   step4Section.classList.remove('question-active');
//   step4Section.classList.add('question-inactive');
//   step5Section.classList.remove('question-inactive');
//   step5Section.classList.add('question-active');
//   updateProgressBar(5);
//   scrollToTop(); // ✅ Scroll to top
// });

// // ============= Step 5: Questionnaire =============
// const answerButtons = document.querySelectorAll('.qf-step-answer');
// const allQuestions = document.querySelectorAll('.qf-step5-single');

// answerButtons.forEach(button => {
//   button.addEventListener('click', function() {
//     const wrapper = this.parentElement;
//     wrapper.querySelectorAll('.qf-step-answer').forEach(ans => ans.classList.remove('active'));
//     this.classList.add('active');
//     checkAllAnswered();
//   });
// });

// function checkAllAnswered() {
//   const allAnswered = Array.from(allQuestions).every(question => question.querySelector('.qf-step-answer.active'));
//   step5Button.disabled = !allAnswered;
//   step5Button.classList.toggle('active', allAnswered);
// }

// step5Button.addEventListener('click', function() {
//   if (!this.disabled) {
//     let allMatched = true;

//     allQuestions.forEach(question => {
//       const flowAtt = question.getAttribute('flow-att');
//       const activeAnswer = question.querySelector('.qf-step-answer.active');
//       if (activeAnswer) {
//         const answerText = activeAnswer.textContent.trim().toLowerCase();
//         const flowAttValue = flowAtt ? flowAtt.toLowerCase() : '';

//         // ✅ allow both answers if flow-att="both"
//         if (flowAttValue !== 'both' && answerText !== flowAttValue) {
//           allMatched = false;
//         }
//       }
//     });

//     step5Section.classList.remove('question-active');
//     step5Section.classList.add('question-inactive');

//     if (allMatched) {
//       step6Section.classList.remove('question-inactive');
//       step6Section.classList.add('question-active');
//       updateProgressBar(6);
//     } else {
//       supportSection.classList.remove('question-inactive');
//       supportSection.classList.add('question-active');
//       updateProgressBar('support');
//     }
//     scrollToTop(); // ✅ Scroll to top
//   }
// });

// // ============= Step 6: Checkbox Validation =============
// const checkboxes = document.querySelectorAll('.qf-step6-input');

// document.querySelectorAll('.qf-step6-checbox-single').forEach(wrapper => {
//   wrapper.addEventListener('click', function(e) {
//     if (e.target.classList.contains('qf-step6-input')) return;
//     const checkbox = this.querySelector('.qf-step6-input');
//     if (checkbox) {
//       checkbox.checked = !checkbox.checked;
//       checkAllCheckboxes();
//     }
//   });
// });

// function checkAllCheckboxes() {
//   const allChecked = Array.from(checkboxes).every(checkbox => checkbox.checked);
//   step6Button.disabled = !allChecked;
//   step6Button.classList.toggle('active', allChecked);
// }

// checkboxes.forEach(checkbox => checkbox.addEventListener('change', checkAllCheckboxes));
// checkAllCheckboxes();

// step6Button.addEventListener('click', function() {
//   if (!this.disabled) {
//     step6Section.classList.remove('question-active');
//     step6Section.classList.add('question-inactive');
//     const packageParam = getUrlParameter('package');
//     filterStep7Packages(packageParam);
//     step7Section.classList.remove('question-inactive');
//     step7Section.classList.add('question-active');
//     updateProgressBar(7);
//     scrollToTop(); // ✅ Scroll to top
//   }
// });








// ============= STEP HISTORY TRACKING =============
let stepHistory = [];

// ============= URL PARAMETER FUNCTIONS =============
function getUrlParameter(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

function updateUrlPage(pageValue) {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('page', pageValue);
  window.history.pushState({}, '', currentUrl);
}

// ============= SCROLL TO TOP HELPER =============
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

// ============= UPDATE PROGRESS BAR =============
function updateProgressBar(stepName) {
  const progressBarWrapper = document.querySelector('.nej-wrapper');
  const thirdStep = document.querySelector('.nej-step1.nej-active-progress');
  
  if (!progressBarWrapper || !thirdStep) return;
  
  // Hide progress bar for consultation, not-eligible, and dis-agree steps
  if (stepName === 'consultion-step' || stepName === 'not-eligible' || stepName === 'dis-agree') {
    progressBarWrapper.style.display = 'none';
    return;
  } else {
    progressBarWrapper.style.display = 'block';
  }
  
  // Get all question steps (step-3 onwards until agreement)
  const allQuestionSteps = document.querySelectorAll('[step-name^="step-"]');
  const questionSteps = Array.from(allQuestionSteps).filter(step => {
    return step.querySelector('.nej-question-wrapper');
  });
  
  const totalQuestions = questionSteps.length;
  
  // Define all progress steps: questions + agreement + final-product
  // We subtract 1 because first question doesn't count as progress
  const totalProgressSteps = totalQuestions + 1; // questions (minus first) + agreement + final-product
  
  // Determine current step index
  let currentStepIndex = 0;
  
  if (stepName === 'step-1' || stepName === 'step-2') {
    // Initial steps - no progress
    currentStepIndex = 0;
  } else {
    const currentQuestionIndex = questionSteps.findIndex(step => step.getAttribute('step-name') === stepName);
    
    if (currentQuestionIndex !== -1) {
      // We're in a question step
      // First question (index 0) = no progress (0)
      // Second question (index 1) = start progress (1)
      // And so on...
      currentStepIndex = currentQuestionIndex;
    } else if (stepName === 'agreement') {
      // Agreement is after all questions
      currentStepIndex = totalQuestions;
    } else if (stepName === 'final-product') {
      // Final product is the last step
      currentStepIndex = totalQuestions + 1;
    }
  }
  
  // Calculate progress percentage for the third line
  const progressPercentage = (currentStepIndex / totalProgressSteps) * 100;
  
  // Get the third step elements
  const thirdStepDot = thirdStep.querySelector('.nej-step-dot');
  const thirdStepLine = thirdStep.querySelector('.nej-step-line');
  const thirdStepLastDot = thirdStep.querySelector('.nej-step-dot-last');
  
  // Apply gradient to the third line based on progress
  if (thirdStepLine) {
    if (progressPercentage === 0) {
      // No progress - all gray
      thirdStepLine.style.background = '#E3E1DF';
    } else if (progressPercentage >= 100) {
      // Complete - all blue
      thirdStepLine.style.background = '#4378FF';
    } else {
      // Partial progress - gradient
      thirdStepLine.style.background = `linear-gradient(to right, #4378FF ${progressPercentage}%, #E3E1DF ${progressPercentage}%)`;
    }
    thirdStepLine.style.transition = 'background 0.4s ease';
  }
  
  // Update first dot color based on progress
  if (thirdStepDot) {
    if (progressPercentage > 0) {
      thirdStepDot.style.background = '#4378FF';
    } else {
      thirdStepDot.style.background = '#E3E1DF';
    }
    thirdStepDot.style.transition = 'background 0.4s ease';
  }
  
  // Update last dot color when reaching final step
  if (thirdStepLastDot) {
    if (progressPercentage >= 100) {
      thirdStepLastDot.style.background = '#4378FF';
    } else {
      thirdStepLastDot.style.background = '#E3E1DF';
    }
    thirdStepLastDot.style.transition = 'background 0.4s ease';
  }
}

// ============= SHOW STEP BY NAME WITH FADE ANIMATION =============
function showStepByName(stepName, callback, addToHistory = true) {
  const allSteps = document.querySelectorAll('[step-name]');
  const targetStep = document.querySelector(`[step-name="${stepName}"]`);
  
  // Add to history if not going back AND not auto-progression
  if (addToHistory) {
    const currentStep = document.querySelector('[step-name].active-step');
    if (currentStep) {
      const currentStepName = currentStep.getAttribute('step-name');
      // Only add if it's not already the last item in history
      if (stepHistory.length === 0 || stepHistory[stepHistory.length - 1] !== currentStepName) {
        stepHistory.push(currentStepName);
      }
    }
  }
  
  // Fade out current active step
  const currentStep = document.querySelector('[step-name].active-step');
  if (currentStep) {
    currentStep.style.opacity = '1';
    currentStep.style.transition = 'opacity 0.3s ease-out';
    currentStep.style.opacity = '0';
    
    setTimeout(() => {
      currentStep.classList.remove('active-step');
      currentStep.style.display = 'none';
      
      // Fade in target step
      if (targetStep) {
        targetStep.style.display = 'block';
        targetStep.style.opacity = '0';
        targetStep.classList.add('active-step');
        
        // ✅ UPDATE URL WITH PAGE ATTRIBUTE VALUE
        const pageValue = targetStep.getAttribute('page');
        if (pageValue) {
          updateUrlPage(pageValue);
        }
        
        // Trigger reflow
        targetStep.offsetHeight;
        
        targetStep.style.transition = 'opacity 0.4s ease-in';
        targetStep.style.opacity = '1';
        
        scrollToTop();
        
        // Update progress bar
        updateProgressBar(stepName);
        
        if (callback) {
          setTimeout(callback, 400);
        }
      }
    }, 300);
  } else {
    // No current step, just show target
    if (targetStep) {
      targetStep.style.display = 'block';
      targetStep.style.opacity = '0';
      targetStep.classList.add('active-step');
      
      // ✅ UPDATE URL WITH PAGE ATTRIBUTE VALUE
      const pageValue = targetStep.getAttribute('page');
      if (pageValue) {
        updateUrlPage(pageValue);
      }
      
      targetStep.offsetHeight;
      
      targetStep.style.transition = 'opacity 0.4s ease-in';
      targetStep.style.opacity = '1';
      
      scrollToTop();
      
      // Update progress bar
      updateProgressBar(stepName);
      
      if (callback) {
        setTimeout(callback, 400);
      }
    }
  }
  
  // Update back button visibility
  updateBackButton();
}

// ============= GO TO PREVIOUS STEP =============
function goToPreviousStep() {
  if (stepHistory.length > 0) {
    const previousStepName = stepHistory.pop();
    
    // Reset the step before showing it
    resetStep(previousStepName);
    
    showStepByName(previousStepName, () => {
      // If it's a step with progress bar, restart it
      const stepSection = document.querySelector(`[step-name="${previousStepName}"]`);
      if (stepSection) {
        const progressBar = stepSection.querySelector('.auto-progress-bar');
        if (progressBar) {
          const nextStepName = getNextStepName(previousStepName);
          handleStepWithProgress(previousStepName, nextStepName, 5000);
        } else if (stepSection.querySelector('.nej-question-wrapper')) {
          // If it's a question step, setup the question
          setupQuestionStep(previousStepName);
        } else if (previousStepName === 'agreement') {
          setupAgreementPage();
        } else if (previousStepName === 'final-product') {
          setupFinalProductPage();
        }
      }
    }, false);
  }
}

// ============= RESET STEP =============
function resetStep(stepName) {
  const stepSection = document.querySelector(`[step-name="${stepName}"]`);
  if (!stepSection) return;
  
  // Reset progress bar
  const progressBar = stepSection.querySelector('.auto-progress-bar');
  if (progressBar) {
    progressBar.innerHTML = '';
  }
  
  // Reset question selections
  const questionWrapper = stepSection.querySelector('.nej-question-wrapper');
  if (questionWrapper) {
    const allBlocks = questionWrapper.querySelectorAll('.nej-single-block');
    allBlocks.forEach(block => {
      const radio = block.querySelector('.nej-qes-inp');
      if (radio) radio.checked = false;
      block.classList.remove('selected');
    });
    
    // Remove this answer from userAnswers array
    userAnswers = userAnswers.filter(ans => ans.step !== stepName);
  }
  
  // Reset agreement popup
  if (stepName === 'agreement') {
    const popup = stepSection.querySelector('.nej-dis-popup');
    const agreeBtn = stepSection.querySelector('.agreement-btn');
    
    if (popup) {
      popup.style.display = 'none';
    }
    
    if (agreeBtn) {
      agreeBtn.disabled = false;
      agreeBtn.style.opacity = '1';
      agreeBtn.style.cursor = 'pointer';
    }
  }
}

// ============= UPDATE BACK BUTTON VISIBILITY =============
function updateBackButton() {
  const backButtons = document.querySelectorAll('.nej-bak-svg');
  
  backButtons.forEach(btn => {
    if (stepHistory.length > 0) {
      btn.style.display = 'flex';
      btn.style.opacity = '1';
      btn.style.cursor = 'pointer';
    } else {
      btn.style.display = 'none';
    }
  });
}

// ============= SETUP BACK BUTTONS =============
function setupBackButtons() {
  const backButtons = document.querySelectorAll('.nej-bak-svg');
  
  backButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      goToPreviousStep();
    });
  });
}

// ============= ANIMATE PROGRESS BAR =============
function animateProgressBar(progressBar, duration = 5000) {
  const progressFill = document.createElement('div');
  progressFill.style.width = '0%';
  progressFill.style.height = '100%';
  progressFill.style.background = '#0066FF';
  progressFill.style.borderRadius = '50px';
  progressFill.style.transition = `width ${duration}ms linear`;
  
  progressBar.innerHTML = '';
  progressBar.appendChild(progressFill);
  
  setTimeout(() => {
    progressFill.style.width = '100%';
  }, 50);
}

// ============= HANDLE STEP WITH PROGRESS BAR =============
function handleStepWithProgress(stepName, nextStepName, duration = 5000) {
  const stepSection = document.querySelector(`[step-name="${stepName}"]`);
  
  if (stepSection) {
    const progressBar = stepSection.querySelector('.auto-progress-bar');
    
    if (progressBar) {
      animateProgressBar(progressBar, duration);
      
      setTimeout(() => {
        if (nextStepName) {
          showStepByName(nextStepName, () => {
            handleStepWithProgress(nextStepName, getNextStepName(nextStepName), duration);
          });
        }
      }, duration);
    }
  }
}

// ============= GET NEXT STEP NAME =============
function getNextStepName(currentStep) {
  const stepMap = {
    'step-1': 'step-2',
    'step-2': 'step-3'
  };
  
  return stepMap[currentStep] || null;
}

// ============= TRACK USER ANSWERS =============
let userAnswers = [];

// ============= SETUP QUESTION RADIO BUTTONS =============
function setupQuestionStep(stepName) {
  const stepSection = document.querySelector(`[step-name="${stepName}"]`);
  if (!stepSection) return;
  
  const questionWrapper = stepSection.querySelector('.nej-question-wrapper');
  if (!questionWrapper) return;
  
  const dataStep = questionWrapper.getAttribute('data-step');
  const allBlocks = questionWrapper.querySelectorAll('.nej-single-block');
  
  allBlocks.forEach(block => {
    block.addEventListener('click', function() {
      // Get the radio input and text
      const radio = this.querySelector('.nej-qes-inp');
      const answerText = this.querySelector('.nej-input-text').textContent.trim().toLowerCase();
      
      // Uncheck all radios in this question
      allBlocks.forEach(b => {
        const r = b.querySelector('.nej-qes-inp');
        r.checked = false;
        b.classList.remove('selected');
      });
      
      // Check this radio
      radio.checked = true;
      this.classList.add('selected');
      
      // Determine if answer is correct and if it's strict
      let isCorrect = false;
      let isStrict = false;
      
      if (dataStep === 'both') {
        // Both answers are acceptable
        isCorrect = true;
      } else if (dataStep.endsWith('*')) {
        // STRICT matching - must match exactly
        isStrict = true;
        const requiredAnswer = dataStep.replace('*', '').toLowerCase();
        isCorrect = (answerText === requiredAnswer);
      } else {
        // Non-strict - preferred answer but both proceed to next
        const preferredAnswer = dataStep.toLowerCase();
        isCorrect = (answerText === preferredAnswer);
      }
      
      // Store answer
      userAnswers.push({
        step: stepName,
        answer: answerText,
        required: dataStep,
        correct: isCorrect,
        strict: isStrict
      });
      
      // Wait a moment then navigate
      setTimeout(() => {
        navigateAfterAnswer(stepName, isCorrect, isStrict);
      }, 500);
    });
  });
}

// ============= NAVIGATE AFTER ANSWER =============
function navigateAfterAnswer(currentStep, isCorrect, isStrict) {
  // Get all question steps
  const allQuestionSteps = document.querySelectorAll('[step-name^="step-"]');
  const questionSteps = Array.from(allQuestionSteps).filter(step => {
    return step.querySelector('.nej-question-wrapper');
  });
  
  const currentIndex = questionSteps.findIndex(step => step.getAttribute('step-name') === currentStep);
  
  // Check if there are more questions
  if (currentIndex < questionSteps.length - 1) {
    // If STRICT matching and answer is wrong → go to not-eligible
    if (isStrict && !isCorrect) {
      showStepByName('not-eligible', () => {
        setupQuestionStep('not-eligible');
      });
    } else {
      // Move to next question (either correct, or non-strict)
      const nextStep = questionSteps[currentIndex + 1];
      const nextStepName = nextStep.getAttribute('step-name');
      
      showStepByName(nextStepName, () => {
        setupQuestionStep(nextStepName);
      });
    }
  } else {
    // This is the last question - check all answers
    const allCorrect = userAnswers.every(ans => ans.correct);
    
    if (allCorrect) {
      // All answers correct - go to agreement
      showStepByName('agreement');
    } else {
      // Some answers incorrect - go to consultation
      showStepByName('consultion-step');
    }
  }
}

// ============= SETUP AGREEMENT PAGE =============
function setupAgreementPage() {
  const agreementSection = document.querySelector('[step-name="agreement"]');
  if (!agreementSection) return;
  
  const agreeBtn = agreementSection.querySelector('.agreement-btn');
  const agreeMore = agreementSection.querySelector('.nej-agree-more');
  const popup = agreementSection.querySelector('.nej-dis-popup');
  const popupYes = agreementSection.querySelector('.nej-popup-yes');
  const popupNo = agreementSection.querySelector('.nej-popup-no');
  
  // Agreement button - go to final-product
  if (agreeBtn) {
    agreeBtn.addEventListener('click', function() {
      showStepByName('final-product', () => {
        setupFinalProductPage();
      });
    });
  }
  
  // Show popup with animation from bottom to top
  if (agreeMore && popup && agreeBtn) {
    agreeMore.addEventListener('click', function() {
      // Disable agreement button when popup shows
      agreeBtn.disabled = true;
      agreeBtn.style.opacity = '0.5';
      agreeBtn.style.cursor = 'not-allowed';
      
      popup.style.display = 'flex';
      popup.style.transform = 'translateY(100%)';
      popup.style.opacity = '0';
      popup.style.transition = 'transform 0.4s ease-out, opacity 0.4s ease-out';
      
      setTimeout(() => {
        popup.style.transform = 'translateY(0%)';
        popup.style.opacity = '1';
      }, 50);
    });
  }
  
  // Popup Yes button - go to dis-agree step
  if (popupYes) {
    popupYes.addEventListener('click', function() {
      showStepByName('dis-agree');
    });
  }
  
  // Popup No button - hide popup and re-enable agreement button
  if (popupNo && popup && agreeBtn) {
    popupNo.addEventListener('click', function() {
      popup.style.transform = 'translateY(100%)';
      popup.style.opacity = '0';
      
      setTimeout(() => {
        popup.style.display = 'none';
        
        // Re-enable agreement button when popup closes
        agreeBtn.disabled = false;
        agreeBtn.style.opacity = '1';
        agreeBtn.style.cursor = 'pointer';
      }, 400);
    });
  }
}

// ============= SETUP FINAL PRODUCT PAGE - FILTER BY PACKAGE =============
function setupFinalProductPage() {
  const finalProductSection = document.querySelector('[step-name="final-product"]');
  if (!finalProductSection) return;
  
  const packageParam = getUrlParameter('package');
  if (!packageParam) return;
  
  // Get all product blocks
  const allProducts = finalProductSection.querySelectorAll('.nej-single-product');
  
  allProducts.forEach(product => {
    const packageName = product.getAttribute('package-name');
    
    if (packageName && packageName.toLowerCase() === packageParam.toLowerCase()) {
      // Show matching product
      product.style.display = 'block';
    } else {
      // Hide non-matching products
      product.style.display = 'none';
    }
  });
}

// ============= INITIALIZE ON PAGE LOAD =============
window.addEventListener('DOMContentLoaded', function() {
  const emailParam = getUrlParameter('email');
  const packageParam = getUrlParameter('package');
  const pageParam = getUrlParameter('page');
  
  // Setup back buttons
  setupBackButtons();
  
  // Check if this is the e-commerce journey page
  if (emailParam && packageParam) {
    console.log('Email:', emailParam);
    console.log('Package:', packageParam);
    console.log('Page:', pageParam);
    
    // Hide all steps initially
    const allSteps = document.querySelectorAll('[step-name]');
    allSteps.forEach(step => {
      step.style.display = 'none';
      step.classList.remove('active-step');
    });
    
    // Clear history for fresh start
    stepHistory = [];
    
    // Find the step that matches the page parameter
    let targetStepName = 'step-3'; // default
    
    if (pageParam) {
      const targetStep = Array.from(allSteps).find(step => {
        return step.getAttribute('page') === pageParam;
      });
      
      if (targetStep) {
        targetStepName = targetStep.getAttribute('step-name');
      }
    }
    
    // Show the target step
    showStepByName(targetStepName, () => {
      if (targetStepName.startsWith('step-') && targetStepName !== 'step-1' && targetStepName !== 'step-2') {
        setupQuestionStep(targetStepName);
      } else if (targetStepName === 'agreement') {
        setupAgreementPage();
      } else if (targetStepName === 'final-product') {
        setupFinalProductPage();
      }
    }, false);
  }
});

// ============= SETUP QUESTIONS AFTER STEP-2 =============
// This will be triggered after step-2 completes
document.addEventListener('DOMContentLoaded', function() {
  // Wait for step-3 to appear, then setup
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      const stepName = mutation.target.getAttribute('step-name');
      
      if (mutation.target.classList.contains('active-step')) {
        if (stepName === 'step-3') {
          setupQuestionStep('step-3');
        } else if (stepName === 'agreement') {
          setupAgreementPage();
        } else if (stepName === 'final-product') {
          setupFinalProductPage();
        }
      }
    });
  });
  
  const step3 = document.querySelector('[step-name="step-3"]');
  if (step3) {
    observer.observe(step3, { attributes: true, attributeFilter: ['class'] });
  }
  
  const agreementStep = document.querySelector('[step-name="agreement"]');
  if (agreementStep) {
    observer.observe(agreementStep, { attributes: true, attributeFilter: ['class'] });
  }
  
  const finalProductStep = document.querySelector('[step-name="final-product"]');
  if (finalProductStep) {
    observer.observe(finalProductStep, { attributes: true, attributeFilter: ['class'] });
  }
});